import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Modal } from "reactstrap";
import { Trans } from 'react-i18next';
import Select from "react-select";
import React, { useCallback, useRef, useState, useEffect } from 'react';
import { GoogleMap, useJsApiLoader, Polygon, Marker } from '@react-google-maps/api';
const containerStyle = {
	width: '100%',
	height: '600px'
};
const center = {
	lat: 24.712186535213522,
	lng: 55.11976906855254
};
const AddressComponent = ({akey, handleFilter, showMarker, showBasic, marker, setMarker, countries, cities, districts, subDistricts, address, setAddress}) => {

	useEffect(()=>{ 
		setTimeout(()=>{
			require('../../common/map-contains.js');
		},1000)
	},[]);

	const { isLoaded } = useJsApiLoader({
		googleMapsApiKey: 'AIzaSyB_0WjJZTplrgiW8rTo3TWx97u-C1WutB0'
	});

	const handleOnClick = (e) => {
		const latLng = e.latLng;

		if (latLng) {
			const lat = latLng.lat();
			const lng = latLng.lng();
			setMarker({
				lat: lat,
				lng: lng,
			});
		}
	};
	return isLoaded ? (
		<div>
			<Row>
				<h2 className="form-label"><Trans>Address</Trans></h2>
				<div className="form-group col-md-3 mt-2">
					<Label className="form-label"><Trans>Name</Trans></Label>
					<Input
					name="title"
					value={address.title}
					className="form-control"
					placeholder="Enter Name "
					type="text"
					onChange={(e) => handleFilter('title', e.target.value, akey)}
					></Input>
				</div>
				<div className="form-group col-md-3 mt-2">
					<Label className="form-label"><Trans>Country</Trans></Label>
					<Select
					name="countryId"
					value={countries.find(option => address.countryId==option.value)}
					options={countries} 
					className="form-control select2"
					onChange={(e) => handleFilter('countryId', e.value, akey)}
					required
					/>
				</div>
				<div className="form-group col-md-3 mt-2">
					<Label className="form-label"><Trans>City</Trans></Label>
					<Select
					name="cityId"
					value={cities.find(option => address.cityId==option.value)}
					options={cities} 
					className="form-control select2"
					onChange={(e) => handleFilter('cityId', e.value, akey)}
					required
					/>
				</div>
				<div className="form-group col-md-3 mt-2">
					<Label className="form-label"><Trans>District</Trans></Label>
					<Select
					name="districtId"
					value={districts.find(option => address.districtId==option.value)}
					options={districts} 
					className="form-control select2"
					onChange={(e) => handleFilter('districtId', e.value, akey)}
					required
					/>
				</div>
				<div className="form-group col-md-3 mt-2">
					<Label className="form-label"><Trans>Sub District</Trans></Label>
					<Select
					name="subDistrictId"
					value={subDistricts.find(option => address.subDistrictId==option.value)}
					options={subDistricts} 
					className="form-control select2"
					onChange={(e) => handleFilter('subDistrictId', e.value, akey)}
					/>
				</div>
        {!showBasic ? (
          <div>
            <div className="form-group col-md-3 mt-2">
              <Label className="form-label"><Trans>Street</Trans></Label>
              <Input
              name="street"
              value={address.street}
              className="form-control"
              placeholder=""
              type="text"
              onChange={(e) => handleFilter('street', e.target.value, akey)}
              ></Input>
            </div>
            <div className="form-group col-md-3 mt-2">
              <Label className="form-label"><Trans>Building</Trans></Label>
              <Input
              name="building"
              value={address.building}
              className="form-control"
              placeholder=""
              type="text"
              onChange={(e) => handleFilter('building', e.target.value, akey)}
              ></Input>
            </div>
            <div className="form-group col-md-3 mt-2">
              <Label className="form-label"><Trans>Phone</Trans></Label>
              <Input
              name="phone"
              value={address.phone}
              className="form-control"
              placeholder=""
              type="text"
              onBlur={(e) => handleFilter('phone', e.target.value, akey)}
              required
              ></Input>
            </div>
            <div className="form-group col-md-3 mt-2">
              <Label className="form-label"><Trans>Flat number</Trans></Label>
              <Input
              name="flatNo"
              value={address.flatNo}
              className="form-control"
              placeholder=""
              type="text"
              onChange={(e) => handleFilter('flatNo', e.target.value, akey)}
              ></Input>
            </div>
        </div>
        ):<></>
        }
			</Row>
      <hr></hr>
      {showMarker ? (
        <div>
        <Row >
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={9}
            onClick={handleOnClick}
          >
          {marker && (
            <Marker
              position={{
                lat: marker.lat,
                lng: marker.lng,
              }}
            />
          )}
          </GoogleMap>
        </Row>
        <br></br>
      </div>
      ) : <></>
      }
		</div>
	) : <></>;
};
export default AddressComponent;
